import { PipeTransform, Pipe } from "@angular/core";
import { trimTextByWord } from "../admin/events-screen/utils/trimTextByWord";

@Pipe({ name: "trimText" })
export class TrimTextPipe implements PipeTransform {
    transform(text: string, maxLength: number = 45): string {
        if (!text) return '';
        return trimTextByWord(text, maxLength);
    }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/trim-text-pipe.ts